// update inputvalue
export function updateValue(value) {
	return {
		type: 'UPDATE_VALUE',
		value
	}
}